import { AxiosError } from 'axios';
import { useState } from 'react';

// import toast from 'react-hot-toast';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { triplogStatsActions } from '../../../redux/slices/triplogStatsSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useTriplogStats = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const dispatch = useAppDisPatch();

    const onTriplogStatsError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(
            'Something went wrong while updating the contact.',
        );
    };

    const onTriplogStatsSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        dispatch(triplogStatsActions.setTriplogStatsData(data));
    };

    const getTriplogStats = () => {
        const url: HttpConfig = {
            url: `api/v1/trip-logs/metrics`,
            method: 'get',
        };
        request(url, onTriplogStatsSuccess, setLoading, onTriplogStatsError);
    };

    return { getTriplogStats, loading };
};

export default useTriplogStats;
